<template>
  <div class="panel panel-default version-card">
    <div class="panel-heading clearfix">
      <div class="row">
        <div class="col-md-6 mt-5 mb-5 header-title">
          <div class="row cust-margin-header">
            <span class="h3-style" data-testid="feature-proj"
              ><strong>Featured Projects</strong>
            </span>
            <popover :content="tooltips.dashboard.featuredProject"></popover>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body mb-20 ml-10 mr-10 feature-proj-container">
      <div
        class="row feature-proj-item mb-10"
        v-for="proj in featuredProjects"
        :key="proj.FK_versionKey"
      >
        <div class="col-md-6">
          <h4>
            <b>{{ proj.versionName }}</b>
          </h4>
        </div>
        <div class="col-md-6 text-right">
          <button
            data-testid="learn-more-btn"
            class="btn btn-default learn-more-btn"
            @click="handleFeatureModal(proj)"
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
    <featured-modal
      :version-key="versionKey"
      :youtube-embed="youtubeEmbed"
      :proj-name="featuredProjectName"
      :feature-card-count="featureProjCardCount"
      :proj-desc="projDescription"
      :youtube-link="youtubeLink"
      :project-info="projectInfo"
    />
  </div>
</template>
<script>
  import FeaturedModal from './FeaturedModal';
  import { mapGetters } from 'vuex';
  export default {
    name: 'FeaturedProjects',
    components: {
      FeaturedModal,
    },
    data() {
      return {
        projectInfo: {},
        featuredProjectName: '',
        projDescription: '',
        youtubeLink: '',
        youtubeEmbed: '',
        featureProjCardCount: 0,
        versionKey: 0,
      };
    },
    methods: {
      handleFeatureModal(proj) {
        this.projectInfo = proj;
        this.featureProjCardCount = this.featureProjectToggleCount(proj);

        this.featuredProjectName = proj.versionName;
        this.projDescription = proj.description;
        this.versionKey = proj.FK_versionKey;
        proj.youtubeLink ? this.extractYoutubeHash(proj.youtubeLink) : (this.youtubeEmbed = '');

        this.youtubeLink = proj.youtubeLink;
        $('#featured-proj-modal').modal('show');
      },
      featureProjectToggleCount(project) {
        const entries = Object.entries(project);
        let count = 0;
        for (let item of entries) {
          const [key, val] = item;
          const isToggle =
            key === 'hasPlayLink' || key === 'hasDownloadProject' || key === 'hasYoutubeUrl';
          if (isToggle && val === 1) {
            count++;
          }
        }

        return count;
      },

      extractYoutubeHash(link) {
        let queryParams = link.split('?')[1];
        if (queryParams.includes('&')) {
          queryParams = queryParams.split('&')[0];
        }

        const embedHash = queryParams.split('v=')[1];
        this.youtubeEmbed = 'https://www.youtube.com/embed/' + embedHash;
      },
    },
    computed: {
      ...mapGetters('versions', ['featuredProjects']),
    },
  };
</script>
<style lang="scss" scoped>
  .h3-style {
    font-size: 24px;
  }
  .cust-margin-header {
    margin-left: 1px;
  }

  @media (min-height: 720px) and (max-height: 749px) {
    .feature-proj-container {
      height: 332px;
      padding-top: 0;
      overflow-y: auto;
    }
  }

  @media (max-height: 768px) and (min-height: 750px) {
    .feature-proj-container {
      height: 265px;
      padding-top: 0;
      overflow-y: auto;
    }
  }

  @media (max-height: 899px) and (min-height: 769px) {
    .feature-proj-container {
      height: 267px;
      padding-top: 0;
      overflow-y: auto;
    }
  }

  @media (max-height: 1079px) and (min-height: 900px) {
    .feature-proj-container {
      height: 265px;
      padding-top: 0;
      overflow-y: auto;
    }
  }

  @media (min-height: 1080px) {
    .feature-proj-container {
      height: 265px;
      padding-top: 0;
      overflow-y: auto;
    }
  }

  .feature-proj-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 52px;
    margin-left: -9px;
    margin-right: -5px;
    border: 1px solid lightgray;
  }

  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }

  .panel-heading {
    border: 0px solid transparent;
  }

  h3 {
    margin-top: 10px;
  }
</style>
